<template>
  <div id="page">
    <div class="allPage" style="display: flex;justify-content: flex-end;align-items: center">
      <div class="m_r_10">第{{ parseInt(pageNum*newPage) - parseInt(pageNum - 1) }}-{{ parseInt(pageNum*newPage)}}条/总共{{totalCount}}条</div>
      <div>
<!--        <span @click="fistPage()" class="botton"><i class="icon iconfont icondouble-arrow-left" style="display: inline-block;font-weight: 100;transform: scale(0.8);"></i></span>-->
        <span @click="prevPage()" class="botton" style="font-size: 0"><i class="icon iconfont iconicon_12"></i></span>
        <span @click="thisPage(1)" v-if="showFirst" class="num">
          1
        </span>
        <span v-if="showFirst">...</span>
        <span @click="thisPage(list)" :key="index" v-for="(list,index) in pageList" :class="list === newPage ? 'num active': 'num'">{{list}}</span>
        <span v-if="showEnd">...</span>
        <span @click="thisPage(newotalPage)" v-if="showEnd" class="num">
          {{newotalPage}}
        </span>
        <!--<span class="little">···</span>-->
        <span @click="nextPage()" class="botton" style="font-size: 0"><i class="icon iconfont iconicon_9"></i></span>
<!--        <span @click="lastPage()" class="botton"><i class="icon iconfont icondouble-arrow-left1" style="display: inline-block;font-weight: 100;transform: scale(0.8);"></i></span>-->
        <div class="numPageDiv" v-if="parseInt(numPage) === 1">
          <div>
            <span>{{ pageNum }}</span>
            <span>条/页</span>
            <i class="icon iconfont iconicon_7"></i>
          </div>
          <div>
            <p @click="childePageNum(item)" :class="pageNum === item.name ? 'numPDiv' : ''" :key="index" v-for="(item, index) in pageSizeList">{{ item.name }}</p>
          </div>
        </div>
        <span style="margin-left: 10px">跳至</span>
        <input @keyup.enter="goToPage()" v-model="goPage" type="text" style="background-color: white;border: 1px solid #DEDEDE;">
        <span>页</span>
        <!--<span  @click="goToPage()"  class="go">GO</span>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page',
  props: [
    'totalPage',
    'totalCount',
    'page',
    'explain',
    'numPage'
  ],
  data () {
    return {
      pageNum: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize,
      newotalPage: this.totalPage,
      newPage: this.page,
      pageList: [],
      goPage: '1',
      showFirst: false,
      showEnd: false,
      pageSizeList: [
        {
          id: 1,
          name: 10
        },
        {
          id: 2,
          name: 20
        },
        {
          id: 3,
          name: 30
        }
      ]
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    console.log(this.newPage)
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    this.getPageList()
  },
  methods: { // 所有的方法封装
    getPageList () {
      this.pageList = []
      if (this.newotalPage <= 10) {
        for (let i = 1; i <= this.newotalPage; i++) {
          this.pageList.push(i)
        }
        this.showFirst = false
        this.showEnd = false
      } else {
        if (this.newotalPage - this.newPage <= 10) {
          for (let i = this.newotalPage - 10; i <= this.newotalPage; i++) {
            this.pageList.push(i)
          }
          this.showEnd = false
          if (this.newotalPage <= 10) {
            this.showFirst = true
          }
        } else {
          if (this.newPage > 5) {
            for (let i = this.newPage - 4; i <= this.newPage + 5; i++) {
              this.pageList.push(i)
            }
            this.showEnd = true
            this.showFirst = true
          } else {
            for (let i = 1; i <= 9; i++) {
              this.pageList.push(i)
            }
            this.showFirst = false
            this.showEnd = true
          }
        }
      }
    },
    fistPage () {
      this.getPageList()
      this.$emit('on-getList', 1)
    },
    lastPage () {
      this.getPageList()
      this.$emit('on-getList', this.newotalPage)
    },
    prevPage () {
      // console.log(this.page)
      if (this.newPage > 1) {
        // console.log(this.newPage)
        this.newPage--
        this.getPageList()
        this.$emit('on-getList', this.newPage)
      }
    },
    nextPage () {
      if (this.newPage < this.newotalPage) {
        // console.log(this.newPage)
        this.newPage++
        this.getPageList()
        this.$emit('on-getList', this.newPage)
      }
    },
    thisPage (page) {
      this.newPage = page
      this.getPageList()
      this.$emit('on-getList', this.newPage)
    },
    goToPage () {
      const num = /^[0-9]*$/
      if (this.goPage) {
        setTimeout(() => {
          if (num.test(this.goPage) && parseInt(this.goPage, 10) > 0 && parseInt(this.goPage, 0) <= this.newotalPage) {
            this.newPage = parseInt(this.goPage, 0)
            this.getPageList()
            this.$emit('on-getList', this.newPage)
          } else {
            this.$commonJs.alertTips({
              type: 'error',
              title: '页码不正确',
              content: '请输入正确的页数',
              stayTime: 2
            })
          }
        }, 100)
      }
    },
    childePageNum (item) {
      this.pageNum = item.name
      // this.pageNum = window.localStorage.getItem(window.location.hash + 'gyspage', this.pageNum) || ''
      window.localStorage.setItem(window.location.hash + 'gyspage', this.pageNum)
      window.location.reload()
    }
  },
  components: {
  },
  watch: {
    totalPage (value) {
      console.log(value)
      this.newotalPage = value
      this.getPageList()
    },
    page (value) {
      this.newPage = value
      this.getPageList()
    }
  }
}
</script>

<style scoped>
.numPageDiv {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  position: relative;
}
.numPageDiv:hover > div:last-child {
  display: inline-block!important;
}
.numPageDiv > div:first-child {
  width: calc(100% - 7px);
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding-right: 5px;
  /*margin-top: 5px;*/
}
.numPageDiv > div:first-child > span:first-child {
  display: inline-block;
  width: 20px;
  height: 17px;
  padding: 5px;
  vertical-align: middle;
}
.numPageDiv > div:last-child {
  width: 100%;
  height: 78px;
  background-color: white;
  text-align: left;
  border-radius: 5px;
  padding: 5px 0;
  position: absolute;
  left: 0;
  bottom: 35px;
  display: none;
}
.numPageDiv > div:last-child > p {
  padding: 5px 10px 5px 12px;
  cursor: pointer;
}
.numPageDiv > div:last-child > p:hover {
  background-color: #59D9A3;
  color: white!important;
}
.numPageDiv > div:last-child > p.active {
  background-color: #59D9A3;
  color: white!important;
}
.numPDiv {
  background-color: #59D9A3!important;
  color: white!important;
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/page.vue